import {Component, Input, OnInit} from '@angular/core';
import {ResponseForm} from '../form/models/responsedemat.model';
import {ResponseStateInstruction} from '../form/models';
import {MessageEnum} from '@Common/neo-components/message/message-enum';

/**
 * Intégre le neoMessage : message et couleur selon état de la demande
 */
@Component({
  selector: 'app-motif-message-response',
  templateUrl: './motif-message-response.component.html',
  styleUrls: ['./motif-message-response.component.scss']
})
export class MotifMessageResponseComponent implements OnInit {
  @Input() response: ResponseForm;
  constructor() { }

  ngOnInit(): void {
  }
  neoTypeMessage(response: ResponseForm) {
    const neoMessageType: Map<ResponseStateInstruction, MessageEnum> = new Map<ResponseStateInstruction, MessageEnum> ([
      [ResponseStateInstruction.incomplete, MessageEnum.warning],
      [ResponseStateInstruction.accepted, MessageEnum.confirm],
      [ResponseStateInstruction.refused, MessageEnum.error],
      [ResponseStateInstruction.closed, MessageEnum.info]
    ]);
    return neoMessageType.get(response?.last_instruction_obj?.state) || null;
  }
}
